import { Divider, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import * as React from 'react';
import { lightDefaultColor } from '../../utils/constants';
import dayjs from 'dayjs';
import { useContext } from 'react';
import { UserContext } from '../../contexts/userContext';
import { useGetPagos } from '../../hooks/getPagos';
import { monthToNumber } from '../../utils/utils';


export function ReporteIngresos() {
  const { user } = useContext(UserContext);
  const pagos = useGetPagos(user);

  if (!pagos) return null;

  const pagosList = pagos.data ?? [];
  if (pagosList.length === 0) return null;

  const anioMasAntiguo = pagosList.reduce((acc, pago) => {
    return pago.anio < acc ? pago.anio : acc;
  }, pagosList[0].anio);

  const meses = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  const anios = [];
  for (let a = dayjs().year(); a >= anioMasAntiguo; a--) anios.push(a);

  return (
    <>
      <Typography fontSize={26}>Reporte de ingresos</Typography>
      <Table style={{ margin: 6 }}>
        <TableBody>
          <TableRow
            key={'encabezado-table-pagos'}
            style={{ borderStyle: 'solid', height: 20, backgroundColor: lightDefaultColor }}
          >
            <TableCell style={{ padding: '0px 16px' }}/>
            <TableCell style={{ padding: '0px 16px' }}/>
            {meses.map((mes) => (
              <TableCell key={`encabezado-${mes}`} style={{ padding: '0px 16px' }}>{mes}</TableCell>
            ))}
          </TableRow>
          {anios.map((anio) => {
            return (
              <TableRow
                key={anio}
                style={{ borderStyle: 'solid' }}
              >
                <TableCell style={{ padding: '0px 16px', backgroundColor: lightDefaultColor, borderStyle: 'solid'  }}>{anio}</TableCell>
                <TableCell style={{ padding: '0px 16px', backgroundColor: lightDefaultColor, borderStyle: 'solid'  }}>
                Efectivo
                  <Divider />
                Transferencia
                </TableCell>

                {meses.map((mes) => {
                  const nroMes = monthToNumber(mes);
                  // Exclude seguros del total de ingresos (se manejan por separado)
                  const pagosPeriodo = pagos.data?.filter((p) => p.anio === anio && nroMes === p.mes && !p.esSeguro);
                  const efectivo = pagosPeriodo?.reduce((ppAcc, pp) => ppAcc += pp.pagos.filter((p) => !p.transferencia).reduce((pAcc, p) => pAcc + p.monto, 0), 0);
                  const transferencia = pagosPeriodo?.reduce((ppAcc, pp) => ppAcc += pp.pagos.filter((p) => p.transferencia).reduce((pAcc, p) => pAcc + p.monto, 0), 0);
                  return (
                    <TableCell key={`${mes}-${anio}`} style={{ padding: '0px 16px' }}>
                      {`$${efectivo ?? 0}`}
                      <Divider />
                      {`$${transferencia ?? 0}`}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
}